import { render, staticRenderFns } from "./ItemUni.vue?vue&type=template&id=11fe8575&scoped=true"
import script from "./ItemUni.vue?vue&type=script&lang=js"
export * from "./ItemUni.vue?vue&type=script&lang=js"
import style0 from "./ItemUni.vue?vue&type=style&index=0&id=11fe8575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fe8575",
  null
  
)

export default component.exports